module.exports = __webpack_public_path__ + "static/media/fbn.886bbc12.svg";